import { Box, Paper } from "@material-ui/core";
import { Theme, makeStyles } from "@material-ui/core/styles";
import { Layout } from "@roc/feature-app-core"
import { observer } from "mobx-react"
import { AppraisalTechDashboardGrid } from "./appraisalTechDashboardGrid";

const useStyles = makeStyles((theme: Theme)=>({
  container: {
    maxWidth: '1400px',
  },
  paper: {
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    padding: '0px',
    borderRadius: '0 !important',
  },
}))

export const AppraisalTechControlDashboard = observer(()=>{
  const classes = useStyles();
  return (
    <Layout
      title="Tech Appraisal Dashboard"
      containerClass={classes.container}>
        <Box display="flex" flexDirection="column" height="100%">
          <Paper className={classes.paper}>
            <AppraisalTechDashboardGrid/>
          </Paper>
        </Box>
      </Layout>
  )
})